// extracted by mini-css-extract-plugin
module.exports = {"styles":"styles___3fn0i"};